import React from 'react';
import PropTypes from 'prop-types';
import UserService from '../../../../services/user.service';

const User = ({
  src,
  item,
  onClick,
  classNaming,
}) => (
  <a className={classNaming} href="#" onClick={e => onClick(e, item.id)}>
    <div className="user-img">
      <img
        src={src}
        alt="msg"
        onError={(e) => { e.target.src = UserService.defaultAvatar; }}
      />
    </div>
    <div className="user-text">
      <h6 className="user-info three-dots">{item.username}</h6>
      <p className="user-message">{item.message}</p>
    </div>
  </a>
);

User.propTypes = {
  src: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  classNaming: PropTypes.string.isRequired,
};

export default User;



// WEBPACK FOOTER //
// ./src/views/modules/messages/user/User.jsx